// extracted by mini-css-extract-plugin
export default {"accelerationIco":"ControlledTable_accelerationIco__5yjUS","decelerationIco":"ControlledTable_decelerationIco__ovjx7"};